import React, { useEffect, useState } from "react";

// reactstrap components
import { Spinner } from "reactstrap";

import { showMessage } from "services/message.js";
import { api_GET } from "services/api_service.js";
import { setObjectCookie} from "services/session.js";

import styles from 'assets/css/FechamentoRelatorio.css'
import styles2 from 'assets/css/home.css'
import styles3 from 'assets/css/main.css'
import styles4 from 'assets/css/menu.css'
import styles5 from 'assets/css/sidebar.css'

import { faUserNurse } from "@fortawesome/free-solid-svg-icons";

import Loading from "components/Loading";

import BASE64_LOGOPREFEITURA from "utils/logoPrefeituraBase64";

import ResumoOrigem, { Totalizadores } from "./FechamentoPeriodoResumoOrigem.js";
import { agruparBfsPorOrigem } from "./fechamentoPeriodoUtils.js";

const BFS_POR_LOTE_RENDERIZADO = 20;

export default function FechamentoPeriodo({history}) {

  const queryString = require('query-string');

  const [loading, setLoading] = useState(false); 
  const [resumo, setResumo] = useState(null);

  async function loadIBFS() {
    const query_string = queryString.parse(window.location.search);

    const hash_usuario = query_string.hash_usuario; 
    const hash_regional = query_string.hash_regional; 

    const filtroRelatorio =
            'hash_regional='+encodeURIComponent(hash_regional) + '&' + 
            'data_inicio='+query_string.data_inicio + '&' + 
            'data_fim='+query_string.data_fim + '&' + 
            'hash_usuario='+encodeURIComponent(hash_usuario);

    try {
      const { data } = await api_GET('FechamentoPeriodo/idBFS?' + filtroRelatorio, query_string.tenantId);
      
      var countRender = 0;
      var renderMultiplosItens = ''

      const renderizarPendentes = () => {
        document.getElementById('dados_bfs').innerHTML += renderMultiplosItens;
        renderMultiplosItens = '';
        countRender = 0;
      };

      const grupos = agruparBfsPorOrigem(Array.isArray(data) ? data : []);

      for (const grupo of grupos){
        renderMultiplosItens += `<div class="bfs_services-title">` + grupo.titulo + `</div>`;

      for (const bfs_id of grupo.bfsIds){
        try {
          const {data: dadosDetalhesBFS} = await api_GET('FechamentoPeriodo/BFSDetalhes/' + bfs_id + '?' + filtroRelatorio, query_string.tenantId);
            var html_bfs_cabecalho = `              
                    <div class="row">
                      <div class="col-md-12 col-xs-12 col-sm-12 col-lg-12">
                          <div class="panel-group" id="bfs_cabecalho_card" role="tablist" aria-multiselectable="true">
                              <div class="panel panel-default">
                                  <div class="panel-heading heading-bfs" role="tab" id="headingBFS" data-toggle="collapse" data-parent="#bfs_cabecalho_card" href="#bfs_cabecalho_collapse" aria-expanded="true" aria-controls="collapseOne">
                                  </div>
                                    <div class="panel-body ml-3 mt-3 mb-3 mr-3">
                                        <div class="row">
                                            <div class="col-md-3 col-sm-3 col-xs-6">
                                                <div class="details"> Nº BFS: ` + dadosDetalhesBFS?.bfs_id + `</div>
                                            </div>
                                            <div class="col-md-3 col-sm-3 col-xs-6">
                                                <div class="details"> Data/Hora Registro: ` + dadosDetalhesBFS?.datahora_registro + `</div>
                                            </div>
                                            <div class="col-md-3 col-sm-3 col-xs-6">
                                                <div class="details"> Data/Hora Fiscalização: ` + dadosDetalhesBFS?.datahora_fiscalizacao + `</div>
                                            </div>
                                            <div class="col-md-3 col-sm-3 col-xs-6">
                                                <div class="details"> Regional: ` + dadosDetalhesBFS?.regional + `</div>
                                            </div>
                                        </div>
                                        <br>
                                        <div class="row">
                                            <div class="col-md-3 col-sm-3 col-xs-6">
                                                <div class="details"> Área: ` + dadosDetalhesBFS?.regional + `</div>
                                            </div>
                                            <div class="col-md-3 col-sm-3 col-xs-6">
                                                <div class="details"> Setor: ` + dadosDetalhesBFS?.setor + `</div>
                                            </div>
                                            <div class="col-md-3 col-sm-3 col-xs-6">
                                                <div class="details"> Frequência: ` + dadosDetalhesBFS?.frequencia + `</div>
                                            </div>
                                            <div class="col-md-3 col-sm-3 col-xs-6">
                                                <div class="details"> Área de Limpeza: ` + dadosDetalhesBFS?.area_limpeza + `</div>
                                            </div>
                                        </div>
                                        <br>
                                        <div class="row">
                                            <div class="col-md-3 col-sm-3 col-xs-6">
                                                <div class="details"> Agente Fiscal: ` + dadosDetalhesBFS?.agente_fiscal + `</div>
                                            </div>
                                            <div class="col-md-3 col-sm-3 col-xs-6">
                                                <div class="details"> Contratada: ` + dadosDetalhesBFS?.contratada + `</div>
                                            </div>
                                        </div>
                                        <br>
                                        <div class="row">
                                            <div class="col-md-12 col-sm-12 col-xs-12">
                                                <div class="details"> Endereço: ` + dadosDetalhesBFS?.endereco + `</div>
                                            </div>
                                        </div>
                                        <br>
                                        <div class="row">
                                            <div class="col-md-4 col-sm-4 col-xs-4">
                                                <div class="details"> Endereço Original: ` + dadosDetalhesBFS?.endereco_original + `</div>
                                            </div>
                                            <div class="col-md-4 col-sm-12 col-xs-4">
                                                <div class="details"> Usuário Alteração Endereço: ` + dadosDetalhesBFS?.usuario_alteracao_coordenada + `</div>
                                            </div>
                                            <div class="col-md-4 col-sm-12 col-xs-4">
                                                <div class="details"> Data Alteração Endereço: ` + dadosDetalhesBFS?.data_alteracao_coordenada + `</div>
                                            </div>
                                        </div>
                                        <br>
                                        <div class="row">
                                            <div class="col-md-4 col-sm-4 col-xs-4">
                                                <div class="details"> Contrato: ` + dadosDetalhesBFS?.contrato_atual + `</div>
                                            </div>
                                        </div>
                                    </div>
                                    <br/>
                              </div>
                          </div>
                      </div>
                    </div>
                  <br/>
                  `;

                  var html_bfs_item = 
                  `
                    <div class="row">
                      <div class="col-md-12 col-xs-12 col-sm-12 col-lg-12">
                          <div class="panel-group" id="bfs_cabecalho_card" role="tablist" aria-multiselectable="true">
                              <div class="panel panel-default">
                                  <div class="panel-heading" role="tab" id="headingBFS" data-toggle="collapse" data-parent="#bfs_cabecalho_card" href="#bfs_cabecalho_collapse" aria-expanded="true" aria-controls="collapseOne">
                                  </div>
                                    <div class="panel-body ml-3 mt-3 mb-3 mr-3">
                                      <table class="table table-striped table-hover" id="tableFiscalizados">
                                        <thead>
                                            <tr>
                                              <th>Serviço</th>
                                              <th>Proatividade</th>
                                              <th>Modalidade</th>
                                              <th>Observações</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        `;

                                        for(var i in dadosDetalhesBFS?.list_bfsItem)
                                        {
                                          html_bfs_item += `
                                            <tr>
                                              <td>` + dadosDetalhesBFS.list_bfsItem[i].servico + `</td>
                                              <td>` + dadosDetalhesBFS.list_bfsItem[i].proatividade + `</td>
                                              <td>` + dadosDetalhesBFS.list_bfsItem[i].modalidade + `</td>
                                              <td>` + dadosDetalhesBFS.list_bfsItem[i].observacao + `</td>
                                            </tr>
                                          `;
                                        };

                                        html_bfs_item += `
                                        </tbody>
                                      </table>
                                    </div>
                                    <br/>
                              </div>
                          </div>
                      </div>
                    </div>
                    <br/> 
                  `;

                  var html_cnc = '';

                  for(var i in dadosDetalhesBFS?.list_bfsItem[0]?.list_cnc)
                  {

                    html_cnc += `

                      <div class="row">
                        <div class="col-md-12 col-xs-12 col-sm-12 col-lg-12">
                            <div class="panel-group" id="bfs_cabecalho_card" role="tablist" aria-multiselectable="true">
                                <div class="panel panel-default">
                                    <div class="panel-heading" role="tab" id="headingBFS" data-toggle="collapse" data-parent="#bfs_cabecalho_card" href="#bfs_cabecalho_collapse" aria-expanded="true" aria-controls="collapseOne">
                                    </div>
                                      <div class="panel-body ml-3 mt-3 mb-3 mr-3">
                                      
                                        <div class="row">
                                          <div class="col-md-4 col-xs-12">
                                              <div class="details">Nº CNC: ` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].cnc_id + `</div>
                                          </div>
                                          <div class="col-md-4 col-xs-12">
                                              <div class="details">Situação Atual: ` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].situacao + `</div>
                                          </div>
                                          <div class="col-md-4 col-xs-12">
                                              <div class="details">Responsividade: ` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].responsividade + `</div>
                                          </div>
                                      </div><br />
                                      <div class="row">
                                          <div class="col-md-4 col-xs-12">
                                              <div class="details">Data/Hora Registro: ` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].datahora_registro + `</div>
                                          </div>
                                      </div><br />
                                      <div class="row">
                                          <div class="col-md-12 col-xs-12">
                                              <div class="details">Descrição do Serviço: ` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].servico + `</div>
                                          </div>
                                      </div><br />
                                      <div class="row">
                                          <div class="col-md-12 col-xs-12">
                                              <div class="details">Observações: ` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].observacao + `</div>
                                          </div>
                                      </div><br />
                                      <div class="row">
                                          <div class="col-md-4 col-xs-6 col-sm-4">
                                            <img src='` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].arquivo1 + `' class="img-responsive">
                                          </div>
                                          <div class="col-md-4 col-xs-6 col-sm-4">`
                    if(!!dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].arquivo2)
                    {
                      html_cnc += `         <img src='` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].arquivo2 + `' class="img-responsive">` 
                    }
                    html_cnc += `         </div>
                                          <div class="col-md-4 col-xs-6 col-sm-4">`
                    if(!!dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].arquivo3)
                    {
                      html_cnc += `         <img src='` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].arquivo3 + `' class="img-responsive">`
                    }
                    html_cnc += `         </div>
                                      </div>

                                      </div>
                                      <br/>
                                </div>
                            </div>
                        </div>
                      </div>
                    <br/>      
                  `;

                  try{
                    
                      for(var r in dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_resposta)
                      {                    
                          html_cnc += `
    
                            <div class="row">
                              <div class="col-md-12 col-xs-12 col-sm-12 col-lg-12">
                                  <div class="panel-group" id="bfs_cabecalho_card" role="tablist" aria-multiselectable="true">
                                      <div class="panel panel-default">
                                          <div class="panel-heading" role="tab" id="headingBFS" data-toggle="collapse" data-parent="#bfs_cabecalho_card" href="#bfs_cabecalho_collapse" aria-expanded="true" aria-controls="collapseOne">
                                          </div>
                                            <div class="panel-body ml-3 mt-3 mb-3 mr-3">
                                            
                                              <div class="row">
                                                <div class="col-md-3 col-xs-12">
                                                    <div class="details">Responsável pelo Resposta: ` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_resposta[r].responsavel + `</div>
                                                </div>
                                                <div class="col-md-3 col-xs-12">
                                                    <div class="details">Data/Hora da Resposta: ` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_resposta[r].datahora_registro + `</div>
                                                </div>
                                                <div class="col-md-3 col-xs-12">
                                                    <div class="details">Data/Hora da Sincronização: ` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_resposta[r].datahora_sincronizacao + `</div>
                                                </div>
                                                <div class="col-md-3 col-xs-12">
                                                    <div class="details">Local de Resposta: ` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_resposta[r].local_resposta + `</div>
                                                </div>
                                            </div>
                                            <br />
                                            <div class="row">
                                                <div class="col-md-4 col-xs-12">
                                                    <div class="details">Tipo do Dispositivo: ` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_resposta[r].tipo_dispositivo + `</div>
                                                </div>
                                                <br /><br />
                                                <div class="col-md-12 col-xs-12">
                                                    <div class="details">
                                                        Observações: <br />
                                                        ` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_resposta[r].observacao + `
                                                    </div>
                                                </div>
                                            </div>
                                            <br />
                                            <div class="row">
                                                <div class="col-md-4 col-xs-6 col-sm-4">
                                                    <img src='` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_resposta[r].arquivo1 + `' class="img-responsive">
                                                </div>
                                                <div class="col-md-4 col-xs-6 col-sm-4">`
                          if(!!dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_resposta[r].arquivo2) 
                          {
                          html_cnc += `           <img src='` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_resposta[r].arquivo2 + 
                          `'                       class="img-responsive">`
                          }
                          html_cnc += `         </div>
                                                <div class="col-md-4 col-xs-6 col-sm-4">`
                          if(!!dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_resposta[r].arquivo3) 
                          {
                          html_cnc += `           <img src='` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_resposta[r].arquivo3 +         `'                       class="img-responsive">`
                          }
                          html_cnc += `     </div>
                                            </div> 
    
                                            </div>
                                            <br/>
                                      </div>
                                  </div>
                              </div>
                            </div>
                          <br/>      
                        `; 
                      }

                      for(var aceite in dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_aceite)
                      {                    
                          html_cnc += `
    
                            <div class="row">
                              <div class="col-md-12 col-xs-12 col-sm-12 col-lg-12">
                                  <div class="panel-group" id="bfs_cabecalho_card" role="tablist" aria-multiselectable="true">
                                      <div class="panel panel-default">
                                          <div class="panel-heading" role="tab" id="headingBFS" data-toggle="collapse" data-parent="#bfs_cabecalho_card" href="#bfs_cabecalho_collapse" aria-expanded="true" aria-controls="collapseOne">
                                          </div>
                                            <div class="panel-body ml-3 mt-3 mb-3 mr-3">
                                            
                                              <div class="row">
                                                <div class="col-md-6 col-xs-12">
                                                    <div class="details">Responsável: ` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_aceite[aceite].responsavel + `</div>
                                                </div>
                                                <div class="col-md-6 col-xs-12">
                                                    <div class="details">Data/Hora: ` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_aceite[aceite].datahora_registro + `</div>
                                                </div>
                                                <br /><br />
                                                <div class="col-md-4 col-xs-12">
                                                  <div class="details">Tipo do Dispositivo: ` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_aceite[aceite].tipo_dispositivo + `</div>
                                                </div>
                                              </div>
                                              <br />
                                              <div class="row">
                                                  <div class="col-md-12 col-xs-12">
                                                      <div class="details">
                                                          Observações: <br />
                                                          ` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_aceite[aceite].observacao + `
                                                      </div>
                                                  </div>
                                              </div> 
    
                                            </div>
                                            <br/>
                                      </div>
                                  </div>
                              </div>
                            </div>
                          <br/>      
                        `; 
                      }

                      for(var acic in dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_acic)
                      {                    
                          html_cnc += `
    
                            <div class="row">
                              <div class="col-md-12 col-xs-12 col-sm-12 col-lg-12">
                                  <div class="panel-group" id="bfs_cabecalho_card" role="tablist" aria-multiselectable="true">
                                      <div class="panel panel-default">
                                          <div class="panel-heading" role="tab" id="headingBFS" data-toggle="collapse" data-parent="#bfs_cabecalho_card" href="#bfs_cabecalho_collapse" aria-expanded="true" aria-controls="collapseOne">
                                          </div>
                                            <div class="panel-body ml-3 mt-3 mb-3 mr-3">
                                              <div class="row">
                                                <div class="col-md-6 col-xs-6">
                                                    <div class="details">Nº ACIC: ` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_acic[acic].acic_id + `</div>
                                                </div>
                                              </div><br />                                          
                                              <div class="row">
                                                <div class="col-md-6 col-xs-6">
                                                    <div class="details">Usuário Responsável pela Reprova: ` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_acic[acic].responsavel + `</div>
                                                </div>
                                              </div><br />
                                              <div class="row">
                                                <div class="col-md-6 col-xs-6">
                                                  <div class="details">Data da Reprova: ` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_acic[acic].datahora_registro + `</div>
                                                  <div></div>
                                                </div>
                                              </div><br />
                                              <div class="row">
                                                <div class="col-md-12 col-xs-12">
                                                  <div class="details">
                                                    Motivo da Reprova: <br />
                                                    ` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_acic[acic].observacao + `
                                                  </div>
                                                </div>
                                              </div>
    
                                            </div>
                                            <br/>
                                      </div>
                                  </div>
                              </div>
                            </div>
                          <br/>      
                        `;

                        for(var acic_confirmacao in dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_acic[acic].list_confirmacao)
                        {                    
                            html_cnc += `
      
                              <div class="row">
                                <div class="col-md-12 col-xs-12 col-sm-12 col-lg-12">
                                    <div class="panel-group" id="bfs_cabecalho_card" role="tablist" aria-multiselectable="true">
                                        <div class="panel panel-default">
                                            <div class="panel-heading" role="tab" id="headingBFS" data-toggle="collapse" data-parent="#bfs_cabecalho_card" href="#bfs_cabecalho_collapse" aria-expanded="true" aria-controls="collapseOne">
                                            </div>
                                              <div class="panel-body ml-3 mt-3 mb-3 mr-3">

                                                <div class="row">
                                                    <div class="col-md-12 col-xs-12">
                                                        <div class="details">` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_acic[acic].list_confirmacao[acic_confirmacao].clausula + `</div>
                                                    </div>
                                                </div><br />
                                                <div class="row">
                                                    <div class="col-md-12 col-xs-12">
                                                        <div class="details">` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_acic[acic].list_confirmacao[acic_confirmacao].multa + `</div>
                                                    </div>
                                                </div><br />
                                                <div class="row">
                                                    <div class="col-md-12 col-xs-12">
                                                        <div class="details">Multa:` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_acic[acic].list_confirmacao[acic_confirmacao].multa + `</div>
                                                    </div>
                                                </div>
                                              </div>
                                              <br/>
                                        </div>
                                    </div>
                                </div>
                              </div>
                            <br/>      
                          `; 
                        }

                        for(var acic_aprovacao in dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_acic[acic].list_aprovacao)
                        {                    
                            html_cnc += `
      
                              <div class="row">
                                <div class="col-md-12 col-xs-12 col-sm-12 col-lg-12">
                                    <div class="panel-group" id="bfs_cabecalho_card" role="tablist" aria-multiselectable="true">
                                        <div class="panel panel-default">
                                            <div class="panel-heading" role="tab" id="headingBFS" data-toggle="collapse" data-parent="#bfs_cabecalho_card" href="#bfs_cabecalho_collapse" aria-expanded="true" aria-controls="collapseOne">
                                            </div>
                                              <div class="panel-body ml-3 mt-3 mb-3 mr-3">

                                                <div class="row">
                                                    <div class="col-md-6 col-xs-6">
                                                        <div class="details">Gestor Responsável pela Reprova: ` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_acic[acic].list_confirmacao[acic_aprovacao].responsavel + `</div>
                                                    </div>
                                                </div><br />
                                                <div class="row">
                                                    <div class="col-md-6 col-xs-6">
                                                        <div class="details">Data: ` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_acic[acic].list_confirmacao[acic_aprovacao].datahora_registro + `</div>
                                                    </div>
                                                </div><br />
                                                <div class="row">
                                                    <div class="col-md-6 col-xs-6">
                                                        <div class="details">Situação: ` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_acic[acic].list_confirmacao[acic_aprovacao].situacao + `</div>
                                                    </div>
                                                </div><br />
                                                <div class="row">
                                                    <div class="col-md-12 col-xs-12">
                                                        <div class="details">
                                                            Observação do Gestor: <br />
                                                            ` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_acic[acic].list_confirmacao[acic_aprovacao].observacao + `
                                                        </div>
                                                    </div>
                                                </div>

                                              </div>
                                              <br/>
                                        </div>
                                    </div>
                                </div>
                              </div>
                            <br/>      
                          `; 
                        }

                        for(var defesa in dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_acic[acic].list_defesa_registrada)
                        {                    
                            html_cnc += `
      
                              <div class="row">
                                <div class="col-md-12 col-xs-12 col-sm-12 col-lg-12">
                                    <div class="panel-group" id="bfs_cabecalho_card" role="tablist" aria-multiselectable="true">
                                        <div class="panel panel-default">
                                            <div class="panel-heading" role="tab" id="headingBFS" data-toggle="collapse" data-parent="#bfs_cabecalho_card" href="#bfs_cabecalho_collapse" aria-expanded="true" aria-controls="collapseOne">
                                            </div>
                                              <div class="panel-body ml-3 mt-3 mb-3 mr-3">

                                                <div class="row">
                                                    <div class="col-md-6 col-xs-6">
                                                        <div class="details">Data: ` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_acic[acic].list_defesa_registrada[defesa].datahora_registro + `</div>
                                                    </div>
                                                </div><br />
                                                <div class="row">
                                                    <div class="col-md-6 col-xs-6">
                                                        <div class="details">Defesa: ` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_acic[acic].list_defesa_registrada[defesa].defesa + `</div>
                                                    </div>
                                                </div><br />
                                                <div class="row">
                                                    <div class="col-md-6 col-xs-6">
                                                        <div class="details">Responsável: ` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_acic[acic].list_defesa_registrada[defesa].responsavel + `</div>
                                                    </div>
                                                </div><br />
                                              </div>
                                              <br/>
                                        </div>
                                    </div>
                                </div>
                              </div>
                            <br/>      
                          `; 
                        }

                        for(var defesa_analise in dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_acic[acic].list_defesa_analise)
                        {                    
                            html_cnc += `
      
                              <div class="row">
                                <div class="col-md-12 col-xs-12 col-sm-12 col-lg-12">
                                    <div class="panel-group" id="bfs_cabecalho_card" role="tablist" aria-multiselectable="true">
                                        <div class="panel panel-default">
                                            <div class="panel-heading" role="tab" id="headingBFS" data-toggle="collapse" data-parent="#bfs_cabecalho_card" href="#bfs_cabecalho_collapse" aria-expanded="true" aria-controls="collapseOne">
                                            </div>
                                              <div class="panel-body ml-3 mt-3 mb-3 mr-3">

                                                <div class="row">
                                                    <div class="col-md-6 col-xs-6">
                                                        <div class="details">Data: ` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_acic[acic].list_defesa_analise[defesa_analise].datahora_registro + `</div>
                                                    </div>
                                                </div><br />
                                                <div class="row">
                                                    <div class="col-md-6 col-xs-6">
                                                        <div class="details">Observação: ` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_acic[acic].list_defesa_analise[defesa_analise].observacao + `</div>
                                                    </div>
                                                </div><br />
                                                <div class="row">
                                                    <div class="col-md-6 col-xs-6">
                                                        <div class="details">Responsável: ` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_acic[acic].list_defesa_analise[defesa_analise].responsavel + `</div>
                                                    </div>
                                                </div><br />
                                              </div>
                                              <br/>
                                        </div>
                                    </div>
                                </div>
                              </div>
                            <br/>      
                          `; 
                        }

                        for(var defesa_gestor in dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_acic[acic].list_defesa_gestor)
                        {                    
                            html_cnc += `
      
                              <div class="row">
                                <div class="col-md-12 col-xs-12 col-sm-12 col-lg-12">
                                    <div class="panel-group" id="bfs_cabecalho_card" role="tablist" aria-multiselectable="true">
                                        <div class="panel panel-default">
                                            <div class="panel-heading" role="tab" id="headingBFS" data-toggle="collapse" data-parent="#bfs_cabecalho_card" href="#bfs_cabecalho_collapse" aria-expanded="true" aria-controls="collapseOne">
                                            </div>
                                              <div class="panel-body ml-3 mt-3 mb-3 mr-3">

                                                <div class="row">
                                                    <div class="col-md-6 col-xs-6">
                                                        <div class="details">Data: ` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_acic[acic].list_defesa_gestor[defesa_gestor].datahora_registro + `</div>
                                                    </div>
                                                </div><br />
                                                <div class="row">
                                                    <div class="col-md-6 col-xs-6">
                                                        <div class="details">Observação: ` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_acic[acic].list_defesa_gestor[defesa_gestor].observacao + `</div>
                                                    </div>
                                                </div><br />
                                                <div class="row">
                                                    <div class="col-md-6 col-xs-6">
                                                        <div class="details">Responsável: ` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_acic[acic].list_defesa_gestor[defesa_gestor].responsavel + `</div>
                                                    </div>
                                                </div><br />
                                                <div class="row">
                                                    <div class="col-md-6 col-xs-6">
                                                        <div class="details">Situação: ` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_acic[acic].list_defesa_gestor[defesa_gestor].situacao + `</div>
                                                    </div>
                                                </div><br />
                                              </div>
                                              <br/>
                                        </div>
                                    </div>
                                </div>
                              </div>
                            <br/>      
                          `; 
                        }

                        for(var recurso in dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_acic[acic].list_recurso_contratada)
                        {                    
                            html_cnc += `
      
                              <div class="row">
                                <div class="col-md-12 col-xs-12 col-sm-12 col-lg-12">
                                    <div class="panel-group" id="bfs_cabecalho_card" role="tablist" aria-multiselectable="true">
                                        <div class="panel panel-default">
                                            <div class="panel-heading" role="tab" id="headingBFS" data-toggle="collapse" data-parent="#bfs_cabecalho_card" href="#bfs_cabecalho_collapse" aria-expanded="true" aria-controls="collapseOne">
                                            </div>
                                              <div class="panel-body ml-3 mt-3 mb-3 mr-3">

                                                <div class="row">
                                                    <div class="col-md-6 col-xs-6">
                                                        <div class="details">Data: ` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_acic[acic].list_recurso_contratada[recurso].datahora_registro + `</div>
                                                    </div>
                                                </div><br />
                                                <div class="row">
                                                    <div class="col-md-6 col-xs-6">
                                                        <div class="details">Responsável: ` + dadosDetalhesBFS.list_bfsItem[0].list_cnc[i].list_acic[acic].list_recurso_contratada[recurso].responsavel + `</div>
                                                    </div>
                                                </div><br />
                                              </div>
                                              <br/>
                                        </div>
                                    </div>
                                </div>
                              </div>
                            <br/>      
                          `; 
                        }
                      }

                  }catch(ex){

                  }


                }

                renderMultiplosItens += html_bfs_cabecalho + html_bfs_item + html_cnc;
                countRender++;

                if(countRender >= BFS_POR_LOTE_RENDERIZADO){
                  renderizarPendentes();
                }

        }catch(error) { 
          showMessage("Aviso", error.message, 'error' , null);
        } 
      } 
      }

      renderizarPendentes();
    }catch(error) {
      showMessage("Aviso", error.message, 'error' , null);
    }
  }

  async function loadResumo() {
    try {
      const query_string = queryString.parse(window.location.search);
      
      const hash_usuario = query_string.hash_usuario; 
      const hash_regional = query_string.hash_regional; 

      setLoading(true); 

      const { data } = await api_GET(
        'FechamentoPeriodo/Resumo?hash_regional=' + 
        encodeURIComponent(hash_regional) + '&' + 
        'data_inicio=' + query_string.data_inicio + '&' + 
        'data_fim=' + query_string.data_fim + '&' + 
        'hash_usuario='+encodeURIComponent(hash_usuario), 
        query_string.tenantId
      );
      
      if (!!data)
      {
        setResumo(data);
        if(query_string.tipoRelatorio === "Completo") loadIBFS(); 
      }
    } catch (error) { 
      showMessage("Erro", "Erro ao buscar dados do resumo.", 'error', null); 
    }finally{
      setLoading(false);
    }
  }
  
  useEffect(() => {
     loadResumo();
  }, []);

  return (
    <div  className="bg-white" style={{ height: '100vh' }}> 
      {loading && <Loading/>}
      <div className="container-fluid">
        <div className="ml-9 col-10">
            <div id="bfs">
              <div id="divImprimir" style={{width: '100%', 'padding' : '10px' , textAlign : 'right'}}>
              <button className="btn btn-info" id="btnImprimir" onClick= { () => {if(!loading){ window.print()};}}> { loading &&  <Spinner size="sm" color="secondary" /> } &nbsp; Imprimir &nbsp; </button>
            </div>

            <section className="bfs_header">
              <div className="bfs_text-center">
                  <div className="bfs_header-title bfs">
                    <img height="50" className="bfs-image" src={"data:image/png;base64," + BASE64_LOGOPREFEITURA} />
                    Relatório para elaboração de <br/> laudo de atestação de serviços regulares
                  </div>
              </div>
            </section>
            
            {!loading && <div>

              <section className="bfs_details">
                <div className="bfs_column-330">
                    LOCAL: <span id="txt_local">{resumo?.regional}</span>
                </div>
                <div className="bfs_column-330">
                    PERÍODO: <span id="txt_periodo">{resumo?.periodo}</span>
                </div>
                <div className="bfs_column-330">
                  EXTRAIDO POR: <span id="txt_usario">{resumo?.usuario}</span>
                </div>
              </section>
            
              <section className="bfs_services">
                <div className="bfs_table" id="bfs_table">
                    <ResumoOrigem
                      titulo={resumo?.subprefeitura?.origem ?? 'Subprefeitura'}
                      tipoServico={resumo?.subprefeitura?.tipo_servico}
                      qntTotalBFS={resumo?.subprefeitura?.qntTotalBFS_Geradas}
                      qntTotalVistorias={resumo?.subprefeitura?.qntTotalBFSItem_Geradas} />
                    <ResumoOrigem
                      titulo={resumo?.climp?.origem ?? 'CLIMP'}
                      tipoServico={resumo?.climp?.tipo_servico}
                      qntTotalBFS={resumo?.climp?.qntTotalBFS_Geradas}
                      qntTotalVistorias={resumo?.climp?.qntTotalBFSItem_Geradas} />

                    <div className="bfs_services-title">Total Subprefeitura + CLIMP</div>
                    <Totalizadores
                      qntBFS={resumo?.qntTotalBFS_Geradas_Geral}
                      qntVistorias={resumo?.qntTotalBFSItem_Geradas_Geral} />
                </div>
              </section>
              
              </div>

            }

            <div class="page-break"></div>

            <div id="dados_bfs" />
            
            </div>

        </div>
      </div>
    </div>
  );
}
